import { Label, SubText, Text } from '@procurify/ui'

import { type UserLike } from '@webapp/core/interfaces/components/UserLike'
import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { PoolAvatars } from './PoolAvatars'
import { WithApprovalPoolTooltip } from '../WithApprovalPoolTooltip'
import { ApprovalPoolLabelStyled } from './styles/ApprovalPoolLabelStyled'

export interface IApprovalPoolLabelProps {
  level: number
  groupName: string
  members: UserLike[]
  disablePopover?: boolean
  fluid?: boolean
  'aria-labelledby'?: string
}

export const ApprovalPoolLabel = ({
  level,
  groupName,
  members,
  disablePopover = false,
  fluid = false,
  'aria-labelledby': ariaLabelledBy,
}: IApprovalPoolLabelProps) => {
  const intl = useProcurifyIntl()

  return (
    <ApprovalPoolLabelStyled fluid={fluid} aria-labelledby={ariaLabelledBy}>
      <WithApprovalPoolTooltip members={members} disabled={disablePopover}>
        <Label fluid={fluid} component={<PoolAvatars members={members} />}>
          <Text textEllipsis>
            {intl.formatMessage(messages.levelText, { level })}
          </Text>
          <SubText textEllipsis>{groupName}</SubText>
        </Label>
      </WithApprovalPoolTooltip>
    </ApprovalPoolLabelStyled>
  )
}
